import React from 'react';

import { Namespace } from 'i18next';

import i18n from '@/i18n';

const useEnglishTranslation = (ns?: Namespace) => {
	return React.useMemo(() => i18n.getFixedT('en', ns), [ns]);
};

export default useEnglishTranslation;
